module.exports = __webpack_public_path__ + "static/media/Lighthouse FX Terms and Conditions.2199915e.pdf";